import React from 'react'
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts'

export default function StatsCard({ title, data, colors, type = 'pie' }) {
  return (
    <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-lg p-4">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-50 mb-4">{title}</h3>
      
      {type === 'pie' ? (
        <div className="h-60">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
                fontSize={10}
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                ))}
              </Pie>
              <Tooltip 
              wrapperStyle={{ fontSize: '12px' }}
              contentStyle={{ fontSize: '12px' }}
              labelStyle={{ fontSize: '12px' }} />
              <Legend  wrapperStyle={{
                fontSize: '12px',
                paddingTop: '10px'
              }}
              iconSize={10}
              iconType="circle"/>
            </PieChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <div className="space-y-4">
          {data.map((item, index) => (
            <div key={index} className="flex items-center justify-between">
              <div className="flex items-center gap-2 text-xs" >
                <div 
                  className="w-3 h-3 rounded-full"
                  style={{ backgroundColor: colors[index % colors.length] }}
                />
                <span style={{ fontSize: '11px' }} className="text-gray-700 dark:text-gray-300">{item.name}</span>
              </div>
              <span className="text-[11px] font-medium text-gray-900 dark:text-gray-50">{item.value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}